import React, { memo, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ValidEmail } from "../../functions/validationFunction";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [logo, setLogo] = useState("");
  const [backgroundImage, setBackgroundImage] = useState(
    ""
  ); // State for background image
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const Login = () => {
    const obj = {
      email: email,
      role: 3,
      password: password,
    };

    if (!ValidEmail(email)) {
      toast.error("Enter Valid Email");
      return;
    }
    if (password.length === 0) {
      toast.error("Password is required to login");
      return;
    }

    axios
      .post(`${BASE_URL}auth/login`, obj, {
        headers: {
          "Content-Type": "application/json",
          "ngrok-skip-browser-warning": true,
        },
      })
      .then(function (response) {
        if (response.data.success === false) {
          toast.error(response.data.message);
        } else {
          const data = response.data.data;
          const token = data && typeof data.token === "string" ? data.token.trim() : "";
          if (!token) {
            toast.error("Login succeeded but no token received.");
            return;
          }
          toast.success(response.data.message);
          localStorage.setItem("user", JSON.stringify(data));
          localStorage.setItem("token", token);
          localStorage.setItem("role", data.role != null ? String(data.role) : "");
          localStorage.setItem("theme", "light-theme");
          console.log("[Login] API response:", response.data);
          setTimeout(() => {
            navigate("/");
            setTimeout(() => window.location.reload(), 100);
          }, 300);
        }
      })
      .catch(function (error) {
        const msg = error.response?.data?.message || error.message;
        console.log("[Login] Error response:", error.response?.data);
        toast.error(msg);
      });
  };

  useEffect(() => {
    getWebsiteInfo();
  }, []);

  const getWebsiteInfo = () => {
    axios
      .get(`${BASE_URL}admin/getWebsiteInfo`, {
        headers: {
          "Content-Type": "application/json",
          version: "1.0.0",
          "ngrok-skip-browser-warning": true,
        },
      })
      .then(function (response) {
        if (response.data.success !== false && response.data.data) {
          setLogo(response.data.data.logo);
          setBackgroundImage(response.data.data.background_image);

          // Dynamically update the browser tab favicon
          const faviconUrl = response.data.data.favicon_icon;
          if (faviconUrl) {
            let link = document.querySelector("link[rel~='icon']");
            if (!link) {
              link = document.createElement("link");
              link.rel = "icon";
              document.head.appendChild(link);
            }
            link.href = faviconUrl;
          }
        }
      })
      .catch(function () {});
  };

  return (
    <>
      <div
        className="authincation h-100"
        style={{
          backgroundImage:
            `url(${backgroundImage})`,
          backgroundSize: "cover",
        }}
      >
        {" "}
        {/* Apply background image */}
        <div className="container h-100">
          <div
            className="row justify-content-center h-100 align-items-center"
            style={{ marginTop: "50px" }}
          >
            <div className="col-md-6">
              <div className="authincation-content">
                <div className="row no-gutters">
                  <div className="col-xl-12">
                    <div className="auth-form">
                      <div className="text-center mb-3">
                        {logo ? (
                          <img src={logo} alt="Welcome!" />
                        ) : (
                          <p>Welcome !</p>
                        )}
                      </div>
                      <h4 className="text-center mb-4">
                        Sign In to your account
                      </h4>
                      <div className="mb-3">
                        <label className="mb-1">
                          <strong>Email</strong>
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter Email"
                          name="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="mb-1">
                          <strong>Password</strong>
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter Password"
                          name="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                      </div>
                      <div className="text-center mt-4">
                        <button
                          type="button"
                          className="btn btn-primary btn-block"
                          onClick={Login}
                        >
                          Sign In
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(Login);
